import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { FooterResource } from 'app/models/FooterResource';
import { UtilsService } from 'app/services/utils.service';
import { DragulaService } from 'ng2-dragula';
import { forkJoin, Subscription } from 'rxjs';
import { KioskListResource } from 'app/models/KioskListResource';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { FooterAndKioskResource } from 'app/models/ClientFooterAndKioskResource';

@Component({
  selector: 'vbn-short-footer',
  templateUrl: './short-footer.component.html',
  styleUrls: ['./short-footer.component.scss']
})
export class ShortFooterComponent implements OnInit, OnDestroy {

  footerResource: FooterResource;
  errorMessage: string;
  selected_language: string = "ro";
  dateNow: Date;
  userRoleId = localStorage.getItem("_roleId");
  footerForm: FormGroup;
  userEmail: string;
  subscription: Subscription;
  contactList: boolean;

  kiosksList: KioskListResource;
  filterCriteria: FilterCriteriaListEdt;
  checkList: any;
  checkObject: any;
  kioskListResource: KioskResource[];
  arrayToSend: any;
  addressParams: any;
  footerRid: any;
  saveErrors: boolean = false;;
  imageToUpload: boolean = false;

  constructor(private fb: FormBuilder,
    private utilsService: UtilsService,
    private service: UtilsService,
    private element: ElementRef,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dragula: DragulaService) {

    this.footerResource = new FooterResource();
    this.footerResource.footerUsefulContactsResourceList = [];
    this.dateNow = new Date();
    this.contactList = true;
    this.subscription = this.dragula.drop.subscribe(value => {
      //  console.log("====>>> Dragula is triggered");
      this.changeOrderIndex(value);
    });
    this.kiosksList = new KioskListResource();
    this.kiosksList.list = new Array<KioskResource>();
    this.filterCriteria = new FilterCriteriaListEdt();
    this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
    this.checkList = new Array();
    this.kioskListResource = new Array<KioskResource>();
    this.arrayToSend = new Array();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getKioskList();
    if (this.router.url != '/add-footer') {
      this.activatedRoute.params.subscribe((params: Params) => {
        if ('json' in params) {
          this.addressParams = JSON.parse(atob(params['json']));
          this.footerRid = this.addressParams.footerRid;
          // this.getFooterContent(this.footerRid);
        }
      });
    }
    this.footerForm = this.fb.group({
      footerTitleRo: ['', [Validators.maxLength(50)]],
      footerTitleEn: ['', [Validators.maxLength(50)]],
      footerTitleFr: ['', [Validators.maxLength(50)]],
      footerTitleDe: ['', [Validators.maxLength(50)]],
      // 3-100 de caractere pentru a interzice introducerea de spatiu
      imageTitleRo: ['', [Validators.maxLength(50)]],
      imageTitleEn: ['', [Validators.maxLength(50)]],
      imageTitleFr: ['', [Validators.maxLength(50)]],
      imageTitleDe: ['', [Validators.maxLength(50)]],
      phoneTitleRo: ['', [Validators.maxLength(50)]],
      phoneTitleEn: ['', [Validators.maxLength(50)]],
      phoneTitleFr: ['', [Validators.maxLength(50)]],
      phoneTitleDe: ['', [Validators.maxLength(50)]],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(3), Validators.pattern("^[0-9]*$")]],
      emailTitleRo: ['', [Validators.maxLength(50)]],
      emailTitleEn: ['', [Validators.maxLength(50)]],
      emailTitleFr: ['', [Validators.maxLength(50)]],
      emailTitleDe: ['', [Validators.maxLength(50)]],
      email: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.email, this.utilsService.NoWhitespaceValidator()]],

      /*   companyName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
        email: ['', [Validators.required, Validators.maxLength(100), Validators.email]],
        phone: ['', [Validators.nullValidator]],
        address: ['', [Validators.nullValidator]],
        role: ['', [Validators.nullValidator]], */
    })
    // this.getFooterContent();

  }

  getKioskList() {
    this.service.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
      .subscribe(
        response => {
          this.kiosksList = response;
          if (this.kiosksList.errorCode == 1002) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get('0 items found after the search!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            });
            this.kiosksList = new KioskListResource();
            this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
            this.kiosksList.list = [];
          }
          this.initializationKioskList();
          if (this.footerRid) {
            this.getFooterContent(this.footerRid);
          }
        },
        error => this.errorMessage = <any>error);
  }

  initializationKioskList() {
    if (this.kiosksList.list == null) {
      this.kioskListResource = []
    } else {
      this.kioskListResource = this.kiosksList.list;
    }
    this.checkList = new Array();
    for (let i = 0; i < this.kiosksList.list.length; i++) {
      this.checkObject = {};
      this.checkObject.kiosk = new FooterAndKioskResource();
      this.checkObject.kiosk = this.kiosksList.list[i];
      this.checkList.push(this.checkObject);
    }
    this.checkObject = {};
  }

  updateCheckedOptionsKiosk(kiosk, event) {
    if (event.target.checked) {
      let termsOrGdpr = new FooterAndKioskResource()
      termsOrGdpr.kiosk = kiosk;
      this.arrayToSend.push(termsOrGdpr);
    } else {
      for (let i = 0; i < this.arrayToSend.length; i++) {
        if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
          this.arrayToSend.splice(i, 1);
          return
        }
      }
    }
  }


  getFooterContent(rid) {
    this.service.get(`admin/footer/getOne?id=${rid}`)
      .subscribe(
        response => {
          // console.log("Footer Info: ", response)
          this.footerResource = response;
          Object.assign(this.kioskListResource, this.kiosksList)
          if (this.kioskListResource.length > 0) {
            for (let i = 0; i < this.kioskListResource.length; i++) {
              for (let j = 0; j < this.footerResource.kioskResourceList.length; j++) {
                if (this.footerResource.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
                  for (let k = 0; k < this.checkList.length; k++) {
                    if (this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
                      this.checkList[k].check = true;
                      this.arrayToSend.push(this.checkList[k]);
                    }
                  }
                }
              }
            }
          }
          this.dateNow = new Date();
          (!this.footerResource.footerUsefulContactsResourceList) && (this.footerResource.footerUsefulContactsResourceList = []);
          if (this.footerResource.errorCode === 11091) {
            this.contactList = false;
          } else {
            this.contactList = true;
          }
        },
        error => this.errorMessage = <any>error);
  }

  changeListenerMainImage($event): void {
    console.log("FFEFFF: ", $event)
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var image = this.element.nativeElement.querySelector('#documentInput');
    if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
      (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
      (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
      (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
      if (file.size < 1000000) {
        myReader.onloadend = (e: any) => {
          image.src = e.target.result;
          console.log("eddddddddddddddd", image);
          this.footerResource.imageString = e.target.result;
          this.imageToUpload = true;
        }
        myReader.readAsDataURL(file);
      } else {
        forkJoin(
          [this.translate.get('Image error'),
          this.translate.get('Image size is more than 1 mb!')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    } else {
      forkJoin(
        [this.translate.get('Image error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
  }

  onSubmit() {
    if (!this.footerForm.valid) {
      this.saveErrors = true;
      forkJoin(
        [this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields!')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return;
    }

    if (this.footerResource.image == null && this.footerResource.imageString == null) {
      forkJoin(
        [this.translate.get('Mising Image'),
        this.translate.get('Please upload the image!')]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return
    }
    if (this.arrayToSend.length == 0) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please check at least 1 kiosk!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      return;
    }
    (!this.footerRid) && (this.footerResource.userEmail = this.userEmail);
    this.footerResource.kioskResourceList = this.arrayToSend;
    this.footerResource.userEmail = this.userEmail;
    this.footerResource.footerUsefulContactsResourceList = [];

    this.service.add('/admin/footer/edit', this.footerResource)
      .subscribe(
        response => {
          console.log("Saved Info: ", response)
          this.footerResource = response;
          this.footerRid = this.footerResource.rid;
          // this.getFooterContent(this.footerRid);
          var image = this.element.nativeElement.querySelector('#documentInput');
          image.src = "";
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Footer saved!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.router.navigate(['/footer-list/']);
        },
        error => this.errorMessage = <any>error);
  }

  addUsefulContact() {
    if (this.footerRid) {
      this.router.navigate(['/add-useful-contacts/' + btoa('{ "footerRid" : "' + this.footerRid + '"}')]);
    } else {
      this.router.navigate(['/add-useful-contacts']);
    }

  }

  editUsefulContact(rid) {
    if (this.footerRid) {
      this.router.navigate(['/edit-useful-contacts/' + btoa('{ "usefulCRid" : "' + rid + '", "footerRid" : "' + this.footerRid + '"}')]);
    } else {
      this.router.navigate(['/edit-useful-contacts/' + btoa('{ "usefulCRid" : "' + rid + '"}')]);
    }
  }

  deleteUsefulContact(rid) {
    this.service.get(`/admin/footer/deleteUsefulContact/${rid}`)
      .subscribe(
        response => {
          if ([9112, 9113].indexOf(response.errorCode) > -1) {
            forkJoin(
              [this.translate.get('Delete error'),
              this.translate.get(`The contact can not be deleted`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            forkJoin(
              [this.translate.get('Success'),
              this.translate.get('Contact was deleted!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          }
          this.getFooterContent(this.footerRid);
        },
        error => this.errorMessage = <any>error);
  }

  changeOrderIndex(value: any) {
    let rid = value[1].getAttribute("usefulC-rid")
    let oldPos = parseInt(value[1].getAttribute("index"))
    let newPos = undefined
    let departmentList = value[2].children;

    for (let i = 0; i < departmentList.length; i++) {
      let k = departmentList[i].getAttribute("usefulC-rid")
      if (rid == k) {
        newPos = i + 1;
        break;
      }
    }

    this.service.add(`/admin/footer/shiftContacts?oldPosition=${oldPos}&newPosition=${newPos}&userEmail=${this.userEmail}&footerId=${this.footerRid}`, null)
      .subscribe(
        response => {
          this.footerResource = response;
          this.footerResource.footerUsefulContactsResourceList = [];
          if ([9115, 9117].indexOf(this.footerResource.errorCode) > -1) {
            forkJoin(
              [this.translate.get('Chance Order error'),
              this.translate.get('The order was not changed')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            forkJoin(
              [this.translate.get('Success'),
              this.translate.get('Order was changed!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          }
          this.getFooterContent(this.footerRid);
        },
        error => this.errorMessage = <any>error);

    setTimeout(() => {
      console.log('------');
    }, 1000);
  }

  showResponsiveDetails(kioskId) {
    const width = window.innerWidth;
    if (width <= 1100) {
      for (let i = 0; i < this.kiosksList.list.length; i++) {
        if (this.kiosksList.list[i].rid == kioskId) {
          this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
        }
        else {
          this.kiosksList.list[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }

  removeImageToBeSaved() {
    this.element.nativeElement.querySelector('#documentInput').src = null;
    this.imageToUpload = false;
    this.footerResource.imageString=null;
  }
}
